function O(n, t, o) {
  const { fbResult: u } = n, r = t == null ? void 0 : t.hcapValue, i = t == null ? void 0 : t.sort, c = o == null ? void 0 : o.country;
  if (r == null || !i || !u)
    return "";
  const s = c != null && T.includes(c);
  return f(r, i, s) ? p(u, r, i, s) : "";
}
function f(n, t, o) {
  return t === I.ASIAN_HANDICAP || n !== 0 || o;
}
function A(n) {
  return n > 0 ? "+" : "";
}
function S(n) {
  return A(n) + (n / 4).toFixed(1);
}
function a(n) {
  return (n > 0 ? [n - 1, n + 1] : [n + 1, n - 1]).map(S).join(", ");
}
function H(n) {
  return n % 2 === 0 ? S(n) : a(n);
}
function d({ handicapValue: n }) {
  return `${n / 4}`;
}
function g({ handicapValue: n }) {
  return n.toString();
}
function e({
  selectionFbResult: n,
  handicapValue: t,
  USEvent: o
}) {
  return o && t === 0 ? "scr" : _(n, t) + Math.abs(t);
}
function l({
  selectionFbResult: n,
  handicapValue: t
}) {
  const o = n === "A" ? -t : t;
  return `${H(o)}`;
}
const N = {
  WH: e,
  MH: e,
  AH: l,
  hl: d,
  HL: g
};
function p(n, t, o, u) {
  const r = N[o];
  return r ? r({ selectionFbResult: n, handicapValue: t, USEvent: u }) : "";
}
function _(n, t) {
  return n === "A" ? t > 0 ? "-" : "+" : t > 0 ? "+" : "-";
}
const I = {
  ASIAN_HANDICAP: "AH"
}, T = ["US", "USA"];
function R(n, t) {
  return n.status === "S" || t.status === "S";
}
function U(n, t, o) {
  return n.status === "S" || t.status === "S" || o.status === "S";
}
const E = "OB_OU", C = (n = "") => n.replace(E, "");
export {
  E as SELECTION_OB_PREFIX,
  O as getSelectionHandicapValue,
  R as isMarketSuspended,
  U as isSelectionSuspended,
  C as removeSelectionPrefix
};
